"use client";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { AppState, AppDispatch } from "@/store/configureStore";
import toast from "react-hot-toast";
import { AVATAR_UPLOAD_API } from "@/constants";
import { updateAvatar } from "@/store/slices/userSlice";

const useAvatarUpload = () => {
	const user = useSelector((state: AppState) => state.user);
	const dispatch = useDispatch<AppDispatch>();

	const handleAvatarUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (!file) {
			return;
		}

		const formData = new FormData();
		formData.append("avatar", file);

		try {
			const response = await axios.put(AVATAR_UPLOAD_API, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
					Authorization: `Bearer ${user?.token}`,
				},
			});

			dispatch(updateAvatar(response?.data?.user?.avatarkey));
			toast.remove();
			toast.success("Avatar uploaded successfully");
		} catch (error: any) {
			// console.log('API Error', error);
			toast.remove();
			toast.error(error?.message || "Failed to upload avatar");
		}
	};

	return {
		handleAvatarUpload,
	};
};

export default useAvatarUpload;
